<template>
  <div> 

    <!-- query is : {{ route }} <br> -->
    <!-- zodiacData.elements is : {{ zodiacData.elements }} <br> -->
    <!-- 9638449 -->
    

    <NavHeader />
    <ProfileLandscapeMode v-if="!mobileView" />
    <ProfilePortraitMode v-if="mobileView" />

    
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ProfileLandscapeMode from '@/components/views/ProfileLandscapeMode.vue';
import ProfilePortraitMode from '@/components/views/ProfilePortraitMode.vue';
import NavHeader from '@/components/NavHeader.vue';



export default {
  data: () => {
    return {
      state: {zodiacDataContainer: []},
      mobileView: true,
      displaySign: 5,
      // signId: ,
      name: 'SignProfiles',
      loading: false,
      post: null,
      error: null,
      props: ['signId'],
    };
  },
  methods: {
    handleView() {
      this.mobileView = window.innerWidth <= 750;
    },

  },
  computed: {
    ...mapState(['zodiacData', 'getZodiacSignProfile', 'currentSignProfile', 'activeSignProfile']),
    test() {
      let selectedProfile2 = this.$store.getters.filterZodiacData(this.$route.params.signId)
      let selectedProfile = JSON.stringify(selectedProfile2);


      if (selectedProfile === 'undefined') {
        console.log('profiles reroute data to not fount page')
      } else {
      console.log('profiles computed selectedProfile is: ', selectedProfile)
        // return this.$store.dispatch('getZodiacSignProfile', selectedProfile)
      }   
      
      
      return console.log('profiles default return')
        //return this.$store.dispatch('getZodiacSignProfile', selectedProfile)

    }
    // ...mapGetters({getZodiacData: 'filterZodiacData'})
  }, 
  components: {
    // signId2ArrayIdCalculator,
    NavHeader,
    ProfileLandscapeMode,
    ProfilePortraitMode
  },
  watch: {
    props: {
      handler(newValue, oldValue){
        console.log('watching signId', newValue, oldValue)
      },
      immediate:true
    },
    displaySign : {
      handler(newValue){
        console.log('watcher for page url displaySign:', this.displaySign, newValue);
      },
      immediate:true
    }
  },
   beforeRouteEnter (to, from, next) {
        // getPost(to.params.signId, (err, post) => {
          // next(vm => { 
          //   vm.signId = store.getters.filterZodiacData(this.$route.params.signId)
            let zodiacSignNames = ['Aries', 'Taurus', 'Gemini', 'Cancer', 'Leo', 'Virgo', 'Libra', 'Scorpio', 'Sagittarius', 'Capricorn', 'Aquarius', 'Pisces']
            const result = zodiacSignNames.filter(zodiacSignNames => zodiacSignNames === to.params.signId);
            // console.log('zodiacData', result);

            result.length !== 0 ? (next(), console.log('found name')) : ( window.location = 'http://localhost:8080', console.log('false not found name'));

            // console.log('tocheck', to.params.signId);
            this.getZodiacNames();

            console.log( 'before check : ', to, 'from is: ', from, 'next is: ', next)
            // next()
          // })
        // })
        
      },
  created() {
    this.handleView();
    window.addEventListener('resize', this.handleView);
     
  },

  unmounted () {
    window.removeEventListener('resize', this.handleView);
    // console.log('unmounted');
  }

};
</script>

<style scoped>

</style>